import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddProductForm from '../components/products/AddProductModal';
import ProductPlanLimitModal from '../components/products/ProductPlanLimitModal';
import { supabase } from '../lib/supabase';
import type { UserOrganisation } from '../types/types';
import { getNumericPlanFeature } from '../util/planFeatures';

export default function AddProduct() {
  const navigate = useNavigate();
  const selectedOrganisation = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.organisation.selected,
  ) as UserOrganisation | undefined;
  const organisationId = selectedOrganisation?.organisation?.id;
  const productLimit = getNumericPlanFeature(
    selectedOrganisation?.organisation?.plan,
    'dppProducts',
  );
  const [checkingLimit, setCheckingLimit] = useState(productLimit != null);
  const [showPlanLimitModal, setShowPlanLimitModal] = useState(false);

  useEffect(() => {
    const checkProductLimit = async () => {
      if (!organisationId || productLimit == null) {
        setCheckingLimit(false);
        setShowPlanLimitModal(false);
        return;
      }

      setCheckingLimit(true);

      const { count, error } = await supabase
        .from('products')
        .select('id', { count: 'exact', head: true })
        .eq('supplier_id', organisationId);

      if (error) {
        setCheckingLimit(false);
        return;
      }

      setShowPlanLimitModal((count ?? 0) >= productLimit);
      setCheckingLimit(false);
    };

    void checkProductLimit();
  }, [organisationId, productLimit]);

  if (checkingLimit) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      {!showPlanLimitModal ? (
        <AddProductForm
          onCancel={() => navigate('/products')}
          onCreated={(productId) => navigate(`/products/${productId}`)}
        />
      ) : null}

      <ProductPlanLimitModal
        show={showPlanLimitModal}
        onHide={() => navigate('/products')}
        onUpgrade={() => navigate('/settings?tab=organisation')}
      />
    </>
  );
}
